module.exports = __webpack_public_path__ + "static/media/smallDeliveryTruck_white.bac28544.svg";